module.exports = __webpack_public_path__ + "static/media/dataMax.b4697886.png";